import React from "react";
import { Link } from "react-router-dom";
import ComponentWrapper from "../Shared/ComponentWrapper";
import hlxPowers from "../../data/HLX-powers.json";
import LottieAnimation from "../Shared/LottieAnimation";

const HelixEcosystem = () => {
  return (
    <ComponentWrapper styles="pt-[5rem] md:pt-[7rem]">
      <div id="hlx" className="w-full grid grid-cols-1 justify-center items-center md:gap-2 gap-8 md:grid-cols-[2fr,1fr]">
        <div className="w-full md:order-1 order-2 flex flex-col gap-7">
          <h2 className="text-[40px] text-center md:text-left text-blue-1 font-medium leading-[40px]">
            HLX powers the Helix AI agent.
          </h2>
          <p className="text-[18px] text-gray-1 text-center md:text-left leading-[28px] ">
            Use HLX to buy Helix Tokens that meter every interaction with
            Helix AI — 1 HLX = 1,000 HT. Stake HLX to earn rewards and vote.
          </p>
          <div className="flex md:justify-start justify-center items-center gap-3">
            <a
              href="https://ai.helix.org"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[14px] font-semibold text-white h-[46px] rounded-[12px] bg-blue-1 px-6
                       transition-all duration-200 ease-in-out
                      shadow-md hover:shadow-lg active:shadow-sm
                      transform hover:scale-105 active:scale-95 flex items-center justify-center"
            >
              Try Helix AI
            </a>
            <Link
              to="/docs/whitepaper"
              className="flex border-[1px] border-gray-2 rounded-[12px] h-[46px] px-6 justify-center items-center gap-2 
                      hover:bg-gray-50 hover:border-gray-300 transition-all duration-200 ease-in-out
                      active:scale-95 transform"
            >
              <p className="text-[14px] font-semibold text-blue-1 transition-colors duration-200">
                View Tokenomics
              </p>
            </Link>
          </div>
          <div className="hidden md:flex pt-5 gap-6">
            <div className="flex sm:flex-row flex-col items-center gap-4">
              <p className="text-[28px] text-blue-1 font-medium">100B</p>
              <p className="text-[18px] text-gray-1 font-medium">
                Total Supply
              </p>
            </div>
            <hr className="w-[1px] h-[64px] bg-gray-1/30" />
            <div className="flex items-center gap-3">
              <p className="text-[28px] text-blue-1 font-medium">25B</p>
              <p className="text-[18px] text-gray-1 font-medium">
                Circulating Supply
              </p>
            </div>
          </div>
        </div>
        <div className="w-full flex-col flex md:order-2 order-1 items-center justify-center md:justify-end">
          <div className="w-[240px] sm:w-[300px] relative h-[315px] sm:h-[390px]">
            <LottieAnimation
              animationData={hlxPowers}
              width="100%"
              height="100%"
            />
            <img
              src="/gr/1.png"
              alt=""
              className="w-[200px] sm:w-[300px] z-10 h-[250px] sm:h-[350px] object-cover absolute -top-[5rem] sm:-top-[7rem] left-[1rem] sm:left-0"
            />
          </div>
          <div className="flex md:hidden justify-center items-center w-full pt-7 sm:pt-5 gap-6">
            <div className="flex sm:flex-row flex-col  items-center gap-0 sm:gap-4">
              <p className="text-[20px] sm:text-[28px] text-blue-1 font-medium">100B</p>
              <p className="text-[16px] sm:text-[18px] text-gray-1 font-medium">
                Total Supply
              </p>
            </div>
            <hr className="w-[1px] h-[50px] sm:h-[64px] bg-gray-1/30" />
            <div className="flex sm:flex-row flex-col  items-center gap-0 sm:gap-3">
              <p className="text-[20px] sm:text-[28px] text-blue-1 font-medium">25B</p>
              <p className="text-[16px] sm:text-[18px] text-gray-1 font-medium">
                Circulating Supply
              </p>
            </div>
          </div>
        </div>
      </div>
    </ComponentWrapper>
  );
};

export default HelixEcosystem;
